function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0.0390625 12C0.0390625 5.37258 5.41165 0 12.0391 0C18.6665 0 24.0391 5.37258 24.0391 12C24.0391 18.6274 18.6665 24 12.0391 24C5.41165 24 0.0390625 18.6274 0.0390625 12Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M12.4389 6.88039C14.1289 6.88039 15.2689 7.61039 15.9189 8.22039L18.4589 5.74039C16.8989 4.29039 14.8689 3.40039 12.4389 3.40039C8.91893 3.40039 5.87893 5.42039 4.39893 8.36039L7.30893 10.6204C8.03893 8.45039 10.0589 6.88039 12.4389 6.88039Z",
  fill: "#EA4335"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M21.079 12.6007C21.079 11.8607 21.019 11.3207 20.889 10.7607H12.439V14.1007H17.399C17.299 14.9307 16.759 16.1807 15.559 17.0207L18.399 19.2207C20.099 17.6507 21.079 15.3407 21.079 12.6007Z",
  fill: "#4285F4"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M7.31896 14.1804C7.12896 13.6204 7.01896 13.0204 7.01896 12.4004C7.01896 11.7804 7.12896 11.1804 7.30896 10.6204L4.39896 8.36035C3.78896 9.58035 3.43896 10.9504 3.43896 12.4004C3.43896 13.8504 3.78896 15.2204 4.39896 16.4404L7.31896 14.1804Z",
  fill: "#FBBC05"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M12.4387 21.4007C14.8687 21.4007 16.9087 20.6007 18.3987 19.2207L15.5587 17.0207C14.7987 17.5507 13.7787 17.9207 12.4387 17.9207C10.0587 17.9207 8.03869 16.3507 7.31869 14.1807L4.40869 16.4407C5.88869 19.3807 8.91869 21.4007 12.4387 21.4007Z",
  fill: "#34A853"
});

function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/Google.590d07fc.svg";
export { ForwardRef as ReactComponent };